module.exports = __webpack_public_path__ + "img/kz.f528d17.svg";